import env                from '../env';
import {
    Message,
    UserSession
}                         from '../types';
import { fetchJSON }      from '../helpers/fetchTools';
import { getQueryString } from '../helpers/queryStringUtils';

// Double click fallback - track sending state to prevent sending duplicate messages
let lockMultipleSend = false;

export default async function sendMessage(session: UserSession, conversationId: number, message: Message) {
    if (lockMultipleSend) {
        return;
    }

    lockMultipleSend = true;

    const jsonData = JSON.stringify({
        conversation_id: conversationId,
        content: message.content,
        provider_name: 'twilio',
        message_template_id: message.templateId,
        activity_type: getQueryString().activity_type
    });

    const requestInit: RequestInit = {
        body: jsonData,
        cache: 'default',
        headers: new Headers({
            'Authorization': `Bearer ${session.token}`,
            'Content-Type': 'application/json'
        }),
        method: 'POST',
        mode: 'cors',
    };

    const result = await fetchJSON(env.TWILIO_SMS_OUTBOUND, requestInit);

    lockMultipleSend = false;

    // we need to keep the reference to the fake ID that we generated when sending the message
    // so that we can identify and replace the correct optimistic message
    const resultWithTemporaryId = {
        ...result,
        details: {
            ...result.details,
            message: {
                ...result.details.message,
                temporary_id: message.id
            }
        }
    };

    return resultWithTemporaryId;
}



// WEBPACK FOOTER //
// ./src/services/SendMessagesService.ts